import React from 'react'
import { Form, Switch } from 'antd'
import { useAssignmentAccess } from '../../../../../../components/access/Access'
import { Perm, State } from '../../../../../../../../constants/assignment-permissions'

const TestExactMatch = () => {
    const { hasAccess: hasEditingPermission } = useAssignmentAccess([Perm.CAN_EDIT, State.NOT_PROCESSING, State.NOT_MBA, State.UNPUBLISHED])

    return (
        <Form.Item name='exactMatch' label='Exact Match' valuePropName='checked' initialValue={false}>
            <Switch aria-label='Exact match' disabled={!hasEditingPermission} />
        </Form.Item>
    )
}

export default TestExactMatch
